import script from "./FeedbackCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackCard.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackCard.vue?vue&type=style&index=0&id=bfc5ddfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfc5ddfe"]])

export default __exports__